export default "__VITE_ASSET__Diyw4YwM__"